import { useIntl } from '@leagueplatform/locales';
import React from 'react';
import { Box, HeadingText, ParagraphText } from '@leagueplatform/genesis-core';
import { ModalWrapper } from '../modal-wrapper/modal-wrapper.component';

const LEGAL_CONTENT_KEYS = [
  'LEGAL_MODAL_BODY_1',
  'LEGAL_MODAL_BODY_2',
  'LEGAL_MODAL_BODY_3',
  'LEGAL_MODAL_BODY_4',
] as const;

const LegalParagraph = ({ messageId }: { messageId: string }) => {
  const { formatMessage } = useIntl();

  return (
    <ParagraphText css={{ marginY: '$oneAndHalf', textAlign: 'left' }}>
      {formatMessage({ id: messageId })}
    </ParagraphText>
  );
};

type LegalModalProps = {
  onClose: () => void;
  isOpen: Boolean;
};

export const LegalModal = ({ onClose, isOpen }: LegalModalProps) => {
  const { formatMessage } = useIntl();
  const modalTitle = formatMessage({ id: 'LEGAL_MODAL_TITLE' });
  if (!isOpen) return null;

  return (
    <ModalWrapper maxWidth="882px" onClose={onClose} modalLabel={modalTitle}>
      <Box css={{ marginX: '$three' }}>
        <HeadingText
          id="modalTitle"
          css={{ marginBottom: '$oneAndHalf' }}
          size="xl"
          level="2"
        >
          {modalTitle}
        </HeadingText>
        {LEGAL_CONTENT_KEYS.map((messageId) => (
          <LegalParagraph key={messageId} messageId={messageId} />
        ))}
      </Box>
    </ModalWrapper>
  );
};
